import { useNavigate } from "react-router-dom";
import { ChevronLeft, Scissors, Wind, ChevronRight } from "lucide-react";

// Grooming Hub — splits Skincare (already separate) from grooming concerns:
// Hair Care + Beard Care. Each lives on its own route with photo upload +
// goal chips + personalised plan.

const TILES = [
  {
    key: "hair",
    label: "Hair Care",
    blurb: "Hair growth, hair loss, dry/oily hair, dandruff, repair, shampoo & conditioner picks.",
    icon: Scissors,
    route: "/improve/grooming/hair",
    testId: "grooming-hair-tile",
  },
  {
    key: "beard",
    label: "Beard Care",
    blurb: "Fuller beard, patchy fix, beard oil & balm, wash, routine, softness, trimmer picks.",
    icon: Wind,
    route: "/improve/grooming/beard",
    testId: "grooming-beard-tile",
  },
];

export default function GroomingHubScreen() {
  const navigate = useNavigate();
  return (
    <div className="screen with-nav fade-in" data-testid="grooming-hub-screen">
      <div className="top-bar">
        <button className="icon-btn" onClick={() => navigate("/improve")} aria-label="Back" data-testid="grooming-back-btn">
          <ChevronLeft size={18} strokeWidth={1.7} />
        </button>
        <div className="logo-mark">GROOMING</div>
        <div style={{ width: 36 }} />
      </div>

      <div className="eyebrow" style={{ marginBottom: 8 }}>GROOMING COACH</div>
      <h2 className="h1" style={{ fontSize: 30, marginBottom: 14, lineHeight: 1.12 }}>
        Hair & beard.<br />
        <em className="serif" style={{ fontStyle: "italic", fontWeight: 300 }}>Done right.</em>
      </h2>
      <p className="body" style={{ color: "var(--text-dim)", marginTop: 0, marginBottom: 18 }}>
        Upload a photo, pick what matters, get a real routine — products, frequency, exactly how to use them.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.key}
              type="button"
              className="card"
              onClick={() => navigate(t.route)}
              data-testid={t.testId}
              style={{
                padding: 18,
                width: "100%",
                textAlign: "left",
                cursor: "pointer",
                display: "flex",
                gap: 14,
                alignItems: "center",
              }}
            >
              <div className="tile-icon" style={{ background: "rgba(232,211,185,0.12)", flexShrink: 0 }}>
                <Icon size={18} color="var(--gold)" strokeWidth={1.7} />
              </div>
              <div style={{ flex: 1 }}>
                <div className="h3" style={{ color: "var(--text)", fontSize: 15 }}>{t.label}</div>
                <div className="tiny" style={{ marginTop: 4, color: "var(--text-faint)", lineHeight: 1.45 }}>
                  {t.blurb}
                </div>
              </div>
              <ChevronRight size={18} strokeWidth={1.5} color="var(--text-faint)" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
